import { render } from "./CommitmentAssignees.vue?vue&type=template&id=d0152f58&scoped=true"
import script from "./CommitmentAssignees.vue?vue&type=script&lang=js"
export * from "./CommitmentAssignees.vue?vue&type=script&lang=js"

import "./CommitmentAssignees.vue?vue&type=style&index=0&id=d0152f58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d0152f58"

export default script